import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NationalityService {

  constructor(
    private http: HttpClient
  ) { }

  getNations(): Observable<any> {
    return this.http.get('https://dev-service.fundeen.com:8080/apiservices/utils/v1/utils/get/countries');
  }

}
